module.exports = "/assets/delice-page/slide_1.jpg?ss6Af2f";